<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { http } from '../../../../services/config/config-receituario'
import { VMoney } from 'v-money'
import notaFiscalService from '@/src/services/api-receituario/nota-fiscal'
import formProdutoEstoque from '@/src/components/form-produto-estoque'
import agronomoService from '@/src/services/agronomo'

import viewerReceituario from '@/src/components/modal-viewer-receita.vue'
import viewerFicha from '@/src/components/modal-viewer-ficha.vue'
import fichaService from '@/src/services/fichaemergencia'
import empresaService from '@/src/services/empresa_sistema'
import receitaService from '@/src/services/receita'

import moment from 'moment'
moment.locale('pt-br')
/**
 * Entrada de Nota Fiscal
 */
export default {
  components: {
    Layout,
    Loading,
    vueDropzone: vue2Dropzone,
    formProdutoEstoque,
    viewerReceituario,
    viewerFicha,
  },
  directives: { money: VMoney },
  data() {
    return {
      agronomoSelecionado: {},
      empresa: {},
      mostraForm: true,
      isLoading: false,
      currentPage: 1,
      perPage: 20,
      produto: {},
      receita: {},
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      nfe: {},
      nfes: [],
      ficha: {},
      clientes: [],
      alvos: [],
      receitasBayer: [],
      emissaoBayer: null,
      receitasBayerField: [
        {
          key: 'ultimaReceitaEmitida',
          label: 'Nº da Receita',
          class: 'size-col-20',
        },
        {
          key: 'nomeProdutor',
          label: 'Produtor',
          class: 'size-col-20',
        },
        {
          key: 'nomeAgronomo',
          label: 'Responsável Técnico',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      notaField: [
        {
          key: 'nf',
          label: 'NF',
          class: 'size-col-20',
        },
        {
          key: 'serie',
          label: 'Série',
          class: 'size-col-20',
        },
        {
          key: 'data_emissao',
          label: 'Data de Emissão',
          class: 'size-col-20',
        },
        {
          key: 'valor',
          label: 'Valor',
          class: 'size-col-20',
        },
        {
          key: 'tipo',
          label: 'Tipo',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      produtosField: [
        {
          key: 'nome',
          label: 'Produto',
          class: 'size-col-20',
        },
        {
          key: 'quantidade',
          label: 'Quantidade',
          class: 'size-col-20',
        },
        {
          key: 'culturas',
          label: 'Culturas',
          class: 'size-col-20',
        },
        {
          key: 'alvos',
          label: 'Alvos',
          class: 'size-col-20',
        },
        {
          key: 'area',
          label: '',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      dropzoneOptions: {
        url: `${http.defaults.baseURL}/nfes/imports?ignoreReceituario=false`,
        thumbnailWidth: 150,
        timeout: 100000,
        maxFilesize: 3,
        maxFiles: 5,
        headers: { Authorization: this.$store.state.auth.currentUser.token },
        addRemoveLinks: true,
        dictRemoveFile: 'Remover arquivo',
      },
      tabIndex: 0,
      empresaData: {}
    }
  },
  computed: {},

  watch: {},

  mounted() {
    this.getEmpresa()
    this.handleConsultarAgronomo()
  },

  methods: {
    handleConsultarAgronomo() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token
      agronomoService
        .listar(token)
        .then((resposta) => {
          this.agronomos = resposta.data.data
          this.agronomoSelecionado.item = {}
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
    novo() {
      this.nfe = {}
      this.receita = {}
      this.receitasBayer = []
      this.emissaoBayer = null
      this.$refs.dropzoneXml.removeAllFiles()
    },
    removeItem(index) {
      this.nfe.produtos.splice(index, 1)
    },
    async buildRevenue() {
      if (this.empresa.id_empresa_sistema === 50) {
        await this.createRevenueBayer()
        return
      }
      else if (this.empresa.id_empresa_sistema === 65) {
        await this.createRevenueSyngenta()
        return
      }
      else if (this.empresa.id_empresa_sistema === 12) {
        await this.createRevenueSyngenta()
        return
      } else
        this.createRevenue(this.nfe, this.nfe.produtos)
    },
    async createRevenueBayer() {
      try {
        const prods = this.nfe.produtos;
        if (this.nfe.produtor.nome_estado === 'Bahia') {
          const batchSize = 1;

          for (let i = 0; i < prods.length; i += batchSize) {
            const batch = prods.slice(i, i + batchSize);
            await this.createRevenue(this.nfe, batch);
          }
        } else {
          const batchSize = 2;

          for (let i = 0; i < prods.length; i += batchSize) {
            const batch = prods.slice(i, i + batchSize);
            await this.createRevenue(this.nfe, batch);
          }
        }
        // if (this.nfe.produtos.length > 14) {
        //   let prods = this.nfe.produtos
        //   const itensAte14 = prods.slice(0, 14)
        //   await this.createRevenue(this.nfe, itensAte14)
        //   const itensDe14A30 = prods.slice(14, 30)
        //   await this.createRevenue(this.nfe, itensDe14A30)
        //   this.emissaoBayer = 'ok'
        //   return
        // }
        // await this.createRevenue(this.nfe, this.nfe.produtos)
        this.emissaoBayer = 'ok'
      } catch (error) {
        this.emissaoBayer = null
        this.isLoading = false
      }
    },
    async createRevenueSyngenta() {
      try {
        const prods = this.nfe.produtos;
        const batchSize = 3;

        for (let i = 0; i < prods.length; i += batchSize) {
          const batch = prods.slice(i, i + batchSize);
          await this.createRevenue(this.nfe, batch);
        }

        this.emissaoBayer = 'ok';
      } catch (error) {
        alert(error);
        this.emissaoBayer = null;
        this.isLoading = false;
      }
    },
    showRevenueBayer(revenue) {
      this.receita = revenue
      this.$bvModal.show('rel-receita-xml')
    },
    async createRevenue(nfe, itens) {
      for (const produto of itens) {
        if (
          produto.cultura == undefined ||
          produto.id_alvo == undefined ||
          produto.id_alvo == 0
        ) {
          this.$bvToast.toast(
            'Existem produtos sem cultura e alvo, pro favor preenche corretamente!',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
          return
        }
      }

      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true

      let receitaData = {
        nf: nfe.nf,
        serie: nfe.serie,
        valor: nfe.valor,
        id_produtor: nfe.id_produtor_rural,
        id_agronomo: this.agronomoSelecionado.item && this.agronomoSelecionado.item.id_agronomo ? this.agronomoSelecionado.item.id_agronomo : null,
        itens: [],
      }
      for (const produto of itens) {
        const item = {
          id_produto: produto.id_produto,
          id_cultura: produto.cultura.idCultura,
          id_alvo: produto.id_alvo,
          quantidade: produto.quantidade,
          quantidadeCalculoArea: produto.quantidadeCalculoArea ? produto.quantidadeCalculoArea : produto.quantidade,
          unidade: produto.unidade,
          area: produto.area,
        }
        receitaData.itens.push(item)
      }

      await notaFiscalService
        .emitirReceita(token, receitaData)
        .then((response) => {
          console.log(response)
          this.receita = response.data.receita

          this.$bvToast.toast('Receituário Gerado!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.isLoading = false

          if (this.empresa.id_empresa_sistema === 50 || this.empresa.id_empresa_sistema === 65 || this.empresa.id_empresa_sistema === 12) {
            this.receitasBayer.push(this.receita)
            return
          }
          this.isLoading = true
          receitaService
            .findById(token, this.receita.idReceita)
            .then((resposta) => {
              this.isLoading = false
              console.log('passou aqui')
              const receitaComplemento = resposta.data.receita

              this.receita.assinatura = receitaComplemento.agronomo.digital_signature
              this.receita.is_sign_produtor =
                receitaComplemento.agronomo.is_sign_prod
              this.receita.hash = receitaComplemento.hash
              this.receita.data_hora = receitaComplemento.data_hora
              this.receita.url_pdf = receitaComplemento.url_pdf
              console.log('passou aqui 1 ')
              console.log(this.receita)
              this.$bvModal.show('rel-receita-xml')
            })
            .catch((error) => {
              console.log(error)
              this.isLoading = false
            })
        })
        .catch((error) => {
          this.$bvToast.toast('Erro ao gerar Receituário!', {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.isLoading = false
        })
    },
    findFichaEmergenciaByMap(map) {
      this.isLoading = true
      fichaService
        .listarByMap(map)
        .then((resposta) => {
          this.ficha = resposta.data.data[0]
          this.isLoading = false
          this.$bvModal.show('rel-ficha-xml')
        })
        .catch((error) => {
          this.fichas = []
          this.isLoading = false
        })
    },
    vsuccess(file, response) {
      const data = response.nfe
      if (this.nfe.produtos != undefined && this.nfe.produtos.length > 0) {
        //let prods = []
        for (const prod of data.produtos) {
          //prods.push(prod);
          this.nfe.produtos.push(prod)
        }
        this.nfe.produtos.forEach((produto, index) => {
          this.selectFirstAlvo(index);
        });
      } else {
        this.nfe = data
      }

      this.isLoading = false
      this.$bvToast.toast('Importado com sucesso!', {
        variant: 'success',
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
      this.$forceUpdate()
    },
    vsending(file, xhr, formData) {
      this.isLoading = true
    },
    verror(file) {
      this.isLoading = false
      this.$bvToast.toast(
        'Não foi possível importar o arquivo, por favor verifique se este arquivo já não foi importado!',
        {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        }
      )
    },
    filterAlvoByCultura(alvos, cultura) {
      this.alvos = alvos.filter((element) => element.idCultura === cultura)
      console.log(this.alvos)
    },
    getEmpresa() {      
      const token = this.$store.state.auth.currentUser.token
      empresaService.listarEmpresa(token).then((resposta) => {
        this.empresaData = resposta.data.empresa[0]
        this.empresa.id_empresa_sistema = this.empresaData.id_empresa_sistema
      })
    },
    
    selectFirstAlvo(index) {
      const alvos = this.nfe.produtos[index].cultura.alvos;
      if (alvos && alvos.length > 0 && !this.nfe.produtos[index].id_alvo) {
        this.nfe.produtos[index].id_alvo = alvos[0].idAlvo;
      }
    },
    getAlvos(index) {
      const produto = this.nfe.produtos[index];

      // Verifica se produto e cultura não são null ou undefined antes de acessar alvos
      if (produto && produto.cultura && produto.cultura.alvos) {
        const alvos = produto.cultura.alvos;

        // Se houver alvos e id_alvo ainda não estiver definido, seleciona o primeiro
        if (alvos.length > 0 && !produto.id_alvo) {
          this.nfe.produtos[index].id_alvo = alvos[0].idAlvo;
        }

        return alvos;
      }

      // Retorna uma lista vazia se cultura ou alvos forem null ou undefined
      return [];
    },
    updateArea(index) {
      const newArea = this.nfe.produtos[index].area;
      for (let i = index + 1; i < this.nfe.produtos.length; i++) {
        this.$set(this.nfe.produtos[i], 'area', newArea);
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-10">
            <div class="titulo">Emitir Receituário Agronômico</div>
            <div class="subTitulo">Emita seu receituário agronômico a partir do XML da nota
              fiscal.</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>
      <div v-if="emissaoBayer == null" class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-12">
              <vue-dropzone id="dropzone" ref="dropzoneXml" :options="dropzoneOptions" :use-custom-slot="true"
                @vdropzone-success="vsuccess" @vdropzone-sending="vsending" @vdropzone-error="verror">
                <div class="text-center">
                  <i class="h1 text-muted uil-cloud-upload"></i>
                  <h3>Selecione o arquivo XML para importação.</h3>
                  <span class="text-muted font-size-13">
                    (O arquivo deve ter no máximo 3MB e seguir o padrão
                    WebReceita.)
                  </span>
                </div>
              </vue-dropzone>
            </div>
          </div>
          <div v-if="nfe.produtor != null">
            <div class="row mt-3">
              <div class="col-md-8">
                <div class="titulo-item">INFORMAÇÕES DO CLIENTE</div>
              </div>
              <div class="col-md-4 mt-3">
                <div class="float-right">
                  <button class="btn btn-info mr-3" @click="novo()">
                    <span>Novo</span>
                  </button>
                  <button class="btn btn-primary" @click="buildRevenue()">
                    <span>Emitir</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label>Cliente: {{ nfe.produtor.nome }}</label>
              </div>
              <div class="col-md-4">
                <label>CPF/CNPJ: {{ nfe.produtor.cpf_cnpj }}</label>
              </div>
              <div class="col-md-4">
                <label>Endereço: {{ nfe.produtor.endereco }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label>Bairro: {{ nfe.produtor.localidade }}</label>
              </div>
              <div class="col-md-4">
                <label>Número: {{ nfe.produtor.numero }}</label>
              </div>
              <div class="col-md-4">
                <label>Complemento: {{ nfe.produtor.complemento }}</label>
              </div>
              <div class="col-md-4">
                <label>CEP: {{ nfe.produtor.cep }}</label>
              </div>
              <div class="col-md-4">
                <label>Estado: {{ nfe.produtor.nome_estado }}</label>
              </div>
              <div class="col-md-4">
                <label>Cidade: {{ nfe.produtor.nome_cidade }}</label>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-12">
                <div class="titulo-item">INFORMAÇÕES DOS PRODUTOS</div>
                <b>Total de Produtos: {{ this.nfe.produtos.length }}</b>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12">
                <b-form-group id="input-group-1" label="Quer alterar o Responsável Técnico Padrão?" label-for="filter">
                  <template slot="description">
                    <b v-if="agronomoSelecionado.item != null">CREA: {{ agronomoSelecionado.item.crea }}</b>
                  </template>
                  <v-select class="style-select" label="nome" :options="agronomos" :reduce="(item) => item"
                    :dense="true" v-model="agronomoSelecionado.item" @input="$forceUpdate()"></v-select>
                </b-form-group>
              </div>
            </div>
            <div class="row mb-5 pb-5">
              <div class="col-md-12 mb-5 pb-5">
                <b-table striped hover responsive="sm" borderless bordered outlined small :items="this.nfe.produtos"
                  :fields="produtosField">
                  <template v-slot:cell(quantidade)="row">
                    <b-form-input type="text" v-model="nfe.produtos[row.index].quantidade"></b-form-input>
                    <strong class="small" style="color: #555;">Quantidade: {{ nfe.produtos[row.index].quantidadeFormatada }}</strong>
                  </template>
                  <template v-slot:cell(culturas)="row">
                    <v-select class="style-select" label="nomeComum" :options="row.item.culturas"
                      :reduce="(cultura) => cultura" :dense="true" v-model="nfe.produtos[row.index].cultura"></v-select>
                  </template>
                  <template v-slot:cell(alvos)="row">
                    <v-select class="style-select" label="nomeComum" :options="getAlvos(row.index)"
                      :reduce="(alvo) => alvo.idAlvo" :dense="true" v-model="nfe.produtos[row.index].id_alvo"
                      outlined></v-select>
                  </template>
                  <template v-slot:cell(area)="row" v-if="empresa.id_empresa_sistema === 50 || empresa.id_empresa_sistema === 111">
                    <b-form-input v-model="nfe.produtos[row.index].area" placeholder="Informar a área"
                      @input="updateArea(row.index)" />
                  </template>
                  <template v-slot:cell(nome)="row">
                    <i v-b-tooltip.hover title="Remove o item" role="button" class="uil uil-trash-alt"
                      style="color: red" @click="removeItem(row.index)"></i>
                    - {{ row.item.nome }}
                  </template>
                  <template v-slot:cell(actions)="row">
                    <b-button class="btn btn-primary" size="sm" variant="success" @click="
        findFichaEmergenciaByMap(nfe.produtos[row.index].mapa)
        ">
                      Ficha de Emergência
                    </b-button>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-md-12 mt-3">
          <div class="float-right">
            <button class="btn btn-primary" @click="novo()">
              <span>Criar nova receita</span>
            </button>
          </div>
        </div>
        <b-table striped hover :fields="receitasBayerField" :items="receitasBayer">
          <template v-slot:cell(actions)="row">
            <div class="btn-group mb-2">
              <button v-b-tooltip.hover.bottom title="Visualizar Receituário" type="button" class="btn btn-light"
                @click="showRevenueBayer(row.item)">
                <i class="uil uil-search"></i>
              </button>
            </div>
          </template>
        </b-table>
      </div>
    </div>
  
    <viewerReceituario id="rel-receita-xml" :receita="receita" :empresa="empresaData"
      :isSignature="empresaData.is_digital_signature"></viewerReceituario>
    <viewerFicha id="rel-ficha-xml" :ficha="ficha"></viewerFicha>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Dancing+Script');

.sig3 {
  font-family: 'Dancing Script';
  font-size: 1.9em;
}

.link-new-register {
  color: red;
}

.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;

  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .titulo-item {
    font-size: 18px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .subtitulo {
    margin-bottom: 10px;
  }

  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }

  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;

    &.botaoTopo {
      float: right;
    }
  }

  .filterButton {
    background-color: #008e74c7;
    padding: 0 20px;
  }

  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>